import React from "react";


const BackarrowIcon = props => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16.828" height="13.208" viewBox="0 0 16.828 13.208">
            <g id="Group_175" data-name="Group 175" transform="translate(-12.172 -13.396)">
                <line id="Line_80" data-name="Line 80" x1="14" transform="translate(14 20)" fill="none" stroke="#fff" stroke-linecap="square" stroke-linejoin="round" stroke-width="2" />
                <path id="Path_339" data-name="Path 339" d="M6.19,11.379,1,6.19,6.19,1" transform="translate(12.586 13.81)" fill="none" stroke="#fff" stroke-linecap="square" stroke-width="2" />
            </g>
        </svg>
    );

}

export default BackarrowIcon;